export default function Footer() {
  return (
    <section className="gfg-footer">
      <div className="gfg-foot-tri" />
      <div className="gfg-f-a gfg-rv">Let's make your</div>
      <div className="gfg-f-b gfg-rv">Independence</div>
      <div className="gfg-f-c gfg-rv">Golden</div>
    </section>
  );
}
